import { getApi, postApi, putApi, deleteApi } from "utils/apiCall";

// Thin wrapper around the Workpulse backend endpoints so the tab components below don't
// each repeat the same literal URLs. Every call goes through getApi/postApi/putApi from
// utils/apiCall.js, matching the rest of this app's admin-side API convention.

export const getActiveFacilities = () => getApi(`/get_all_active_facility`);

export const getAllFacilityTokens = () => getApi(`/get_all_workpulse_facility_tokens`);
export const generateFacilityToken = (facilityId) => postApi(`/generate_workpulse_facility_token`, { facility_id: facilityId });
export const revokeFacilityToken = (id) => putApi(`/revoke_workpulse_facility_token/${id}`, {});

export const unpairTablet = (tabletId) => putApi(`/unpair_workpulse_tablet/${tabletId}`, {});
export const renameTablet = (tabletId, deviceLabel) => putApi(`/rename_workpulse_tablet/${tabletId}`, { device_label: deviceLabel });

export const getStaffListing = (params) => getApi(`/api/staff/listing?${params.toString()}`);
export const getAllStaffTokenStatus = () => getApi(`/get_all_workpulse_staff_token_status`);
export const issueStaffToken = (userId) => postApi(`/issue_workpulse_staff_token`, { user_id: userId });
export const revokeStaffToken = (tokenId, reason) => putApi(`/revoke_workpulse_staff_token/${tokenId}`, { reason });
export const reissueStaffToken = (tokenId, userId) => putApi(`/reissue_workpulse_staff_token/${tokenId}`, { user_id: userId });

export const getAllShiftAssignments = () => getApi(`/get_all_workpulse_shift_assignments`);
export const addShiftAssignment = (data) => postApi(`/add_workpulse_shift_assignment`, data);
export const editShiftAssignment = (id, data) => putApi(`/edit_workpulse_shift_assignment_by_id/${id}`, data);
export const deleteShiftAssignment = (id) => deleteApi(`/delete_workpulse_shift_assignment_by_id/${id}`);

export const getAllSessions = (params) => getApi(`/get_all_workpulse_sessions?${params.toString()}`);
export const addManualSession = (data) => postApi(`/add_workpulse_manual_session`, data);
export const correctSession = (id, data) => putApi(`/correct_workpulse_session/${id}`, data);
export const getSessionHistory = (id) => getApi(`/get_workpulse_session_history/${id}`);
